import React from "react";

import { useLogAnalytics } from "@editor/hooks/useLogAnalytics";
import { docs } from "@editor/utils/docs";

import IconButton from "@replo/design-system/components/button/IconButton";
import { Book } from "lucide-react";

type AnalyticsPageHeaderProps = {
  header: React.ReactNode;
};

export const AnalyticsPageHeader: React.FC<AnalyticsPageHeaderProps> = ({
  header,
}) => {
  const analytics = useLogAnalytics();

  return (
    <div className="flex flex-row justify-between">
      {header}
      <IconButton
        icon={<Book size={16} />}
        size="base"
        variant="secondary"
        onClick={() => {
          analytics("analytics.definitions.open", {});
        }}
        to={docs.abTesting.metricDefinitions}
        target="_blank"
        rel="noopener noreferrer"
        tooltipText="Metric Definitions"
      />
    </div>
  );
};
